import React from "react";
import PropTypes from "prop-types";
import { formatMonthLabel } from "../pages/month/monthSeo";
import { getLatestBestOfYearMonth } from "../utils/bestOfMonth";
import { handleInternalLinkClick } from "../utils/navigation";

const SiteBrowseLinks = ({ onNavigate = null }) => {
  const yearMonth = getLatestBestOfYearMonth();
  const links = [
    ["/most-recommended", "Recommendations"],
    [`/best-of/${yearMonth}`, `Best of ${formatMonthLabel(yearMonth)}`],
  ];

  return (
    <>
      {links.map(([href, label]) => (
        <a
          key={href}
          href={href}
          onClick={(event) => {
            onNavigate?.();
            handleInternalLinkClick(event, href);
          }}
          className="site-browse-link"
        >
          {label}
        </a>
      ))}
    </>
  );
};

SiteBrowseLinks.propTypes = { onNavigate: PropTypes.func };
export default SiteBrowseLinks;
